import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from '@modules/constants-enumerate';

const sdo = {
  namespace: sdoNs.SITE_NAVIGATION,
  mutations: {

    /**
     *
     * @return {Object}
     */
    init() {
      return {
        backBtnUrl: null,
        title: null,
      };
    },
  },
  decorators: []
};

storeInstance.addState(sdo);
